import axios from 'axios';

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || 'https://api.razee.app';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

export const saveDietaryPreferences = (data) => api.post('/api/onboarding/dietaryPreferences', data);

export const saveCulturalPreferences = (data) =>
  api.post('/api/onboarding/culturalPreferences', data);

export const saveNursingTime = (data) => api.post('/api/onboarding/nursingTime', data);

export const saveDoctorAppointment = (data) => api.post('/api/onboarding/doctorAppointment', data);

export const saveHealthGoals = (data) => api.post('/api/prescreening/healthGoals', data);

export const saveDiseaseInformation = (data) =>
  api.post('/api/prescreening/diseaseInformation', data);

export const saveLabTest = (formData) =>
  api.post('/api/prescreening/labTest', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const savePackage = (data) => api.post('/api/prescreening/package', data);

export const saveLocation = (data) => api.post('/api/prescreening/location', data);

export const savePayment = (data) =>
  api.post('/api/prescreening/payment', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const saveConfirmation = (data) => api.post('/api/prescreening/confirmation', data);

export const getPackages = (userId, healthGoals, currentDiseases) =>
  api.post('/api/prescreening/packages', {
    userId,
    healthGoals,
    currentDiseases,
  });
